import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormTextWithFileDropAndAddMore from '../../../FormFields/FormTextWithFileDropAndAddMore';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { BUSINESS_DEVELOPMENT } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

ReferralSoftwareForm.propTypes = {
  permissions: PropTypes.object,
};

export default function ReferralSoftwareForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const showForm = BUSINESS_DEVELOPMENT.REFERRAL_SOFTWARES.id in permissions;

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Referral Software
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {BUSINESS_DEVELOPMENT.REFERRAL_SOFTWARES.id in permissions && (
            <Grid item xs={12}>
              <FormTextWithFileDropAndAddMore
                fieldName="referralSoftwares"
                requireNameWhenHasFiles
                fieldAttributes={{
                  isEditable: permissions[BUSINESS_DEVELOPMENT.REFERRAL_SOFTWARES.id],
                  fileTypeId: FILE_TYPES.REFERRAL_SOFTWARE,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
